// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageNotFound_wrapper__Act_o","eyes":"PageNotFound_eyes__jmRac","title":"PageNotFound_title__tX2Cu","return_button":"PageNotFound_return_button__TjLoM"};